import { createReducer } from "../../common/reduxUtil";
import {
  SHOW_BOTTOM_BAR,
  HIDE_TOP_BAR,
  HIDE_BOTTOM_BAR,
  SHOW_TOP_BAR,
  SHOW_SUB_NAV_BAR,
  HIDE_SUB_NAV_BAR,
} from "./types";

const initialState = {
  isTopBarVisible: true,
  isBottomBarVisible: true,
  isSubNavbarVisible: true,
};

export default createReducer(initialState, {
  [SHOW_TOP_BAR]: (state) => {
    return Object.assign({}, state, {
      isTopBarVisible: true,
    });
  },
  [HIDE_TOP_BAR]: (state) => {
    return Object.assign({}, state, {
      isTopBarVisible: false,
    });
  },
  [SHOW_BOTTOM_BAR]: (state) => {
    return Object.assign({}, state, {
      isBottomBarVisible: true,
    });
  },
  [HIDE_BOTTOM_BAR]: (state) => {
    return Object.assign({}, state, {
      isBottomBarVisible: false,
    });
  },
  [SHOW_SUB_NAV_BAR]: (state) => {
    return Object.assign({}, state, {
      isSubNavbarVisible: true,
    });
  },
  [HIDE_SUB_NAV_BAR]: (state) => {
    return Object.assign({}, state, {
      isSubNavbarVisible: false,
    });
  },
});
